<template>
  <g>
    <defs>
      <path
        id="logout@1x-a"
        d="M11.17893,12.091405 L11.17893,4.912305 C11.17893,4.408255 11.58778,4.000255 12.09183,4.000255 C12.59588,4.000255 13.00388,4.408255 13.00388,4.912305 L13.00388,12.091405 C13.00388,12.595455 12.59588,13.004305 12.09183,13.004305 C11.58778,13.004305 11.17893,12.595455 11.17893,12.091405 Z M20.18298,12.091405 C20.18298,16.553055 16.55348,20.182555 12.09183,20.182555 C7.63018,20.182555 3.99983,16.553055 3.99983,12.091405 C3.99983,9.113005 5.61398,6.489055 8.04498,5.083155 C8.48103,4.830705 9.03948,4.979455 9.29193,5.416355 C9.54438,5.852405 9.39563,6.410855 8.95873,6.663305 C7.02583,7.781055 5.82563,9.861005 5.82563,12.091405 C5.82563,15.546655 8.63658,18.357605 12.09183,18.357605 C15.54708,18.357605 18.35803,15.546655 18.35803,12.091405 C18.35803,9.861005 17.15698,7.781055 15.22408,6.662455 C14.78803,6.410855 14.63843,5.852405 14.89088,5.416355 C15.14333,4.979455 15.70178,4.830705 16.13783,5.083155 C18.56713,6.488205 20.18298,9.110455 20.18298,12.091405 L20.18298,12.091405 Z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <rect
        width="24"
        height="24"
        fill="#E3E3E3"
        fill-opacity=".01"
        style="mix-blend-mode:color-burn"
      />
      <use :fill="currentColor" :opacity="opacity" xlink:href="#logout@1x-a" />
    </g>
  </g>
</template>

<script>
  export default {
    props: {
      currentColor: {
        type: String,
        default: 'black'
      },
      opacity: {
        type: String,
        default: '1'
      }
    }  
  }
</script>